$(document).ready(function () {
  $(".img-slider").owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 8000,  // <-- Slower transition interval (8 seconds)
    autoplaySpeed: 1500,    // <-- Smoother slide animation (1.5 seconds)
    navText: ['<span class="left"></span>', '<span class="right"></span>'],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  });
});